var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import attentionBoxCss from "./attention-box.css.js";
import alertsCss from "../../css/alerts.css.js";
export var AttentionType;
(function (AttentionType) {
    AttentionType["Context"] = "context";
    AttentionType["Info"] = "info";
    AttentionType["Success"] = "success";
    AttentionType["Question"] = "question";
    AttentionType["Warning"] = "warning";
    AttentionType["Error"] = "error";
    AttentionType["Danger"] = "danger";
})(AttentionType || (AttentionType = {}));
let AttentionBox = class AttentionBox extends LitElement {
    constructor() {
        super();
        this.type = AttentionType.Context;
        //this.headerText = 'information'
        this.closeable = false;
    }
    hide() {
        this.alert.hide();
    }
    show() {
        this.alert.show();
    }
    getIcon() {
        switch (this.type) {
            case AttentionType.Context:
                return 'braces-asterisk';
            case AttentionType.Info:
                return 'info-square';
            case AttentionType.Warning:
                return 'exclamation-triangle';
            case AttentionType.Error:
                return 'exclamation-square';
            case AttentionType.Danger:
                return 'exclamation-square';
            case AttentionType.Success:
                return 'check-square';
            case AttentionType.Question:
                return 'question-square';
        }
    }
    render() {
        if (!this.type) {
            this.type = AttentionType.Context;
        }
        if (this.type === AttentionType.Danger) {
            this.type = AttentionType.Error;
        }
        let header = html ``;
        if (this.headerText?.length > 0) {
            header = html `<strong>${this.headerText}</strong>`;
        }
        let alert = html `
            <sl-alert class="${this.type}" open>
                    <sl-icon slot="icon" name="${this.getIcon()}" class="${this.headerText ? '' : 'noheader'}"></sl-icon>
                    ${header}
                    <slot></slot>
                </sl-alert>`;
        if (this.closeable) {
            alert = html `
            <sl-alert class="${this.type}" open closable>
                    <sl-icon slot="icon" name="${this.getIcon()}" class="${this.headerText ? '' : 'noheader'}"></sl-icon>
                    ${header}
                    <slot></slot>
                </sl-alert>`;
        }
        return html `
            <div class='attention ${this.type}'>
                ${alert}
            </div>
        `;
    }
};
AttentionBox.styles = [alertsCss, attentionBoxCss];
__decorate([
    property()
], AttentionBox.prototype, "type", void 0);
__decorate([
    property()
], AttentionBox.prototype, "headerText", void 0);
__decorate([
    property({ type: Boolean })
], AttentionBox.prototype, "closeable", void 0);
__decorate([
    query('sl-alert')
], AttentionBox.prototype, "alert", void 0);
AttentionBox = __decorate([
    customElement('pb33f-attention-box')
], AttentionBox);
export { AttentionBox };
